import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import ReactTooltip from "react-tooltip";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
// import ToolkitProvider, { ColumnToggle } from 'react-bootstrap-table2-toolkit';

import CollapsibleNote from "../base/CollapsibleNote";
import ValColumnSelector from "../main/ValColumnSelector";
import NetworkInline from './NetworkInline';
import Contact from "../base/Contact";
import UITableUtils from "../util/UITableUtils";

import UIUtils from "../util/UIUtils";
import ApiUtils from '../util/ApiUtils';
import "./Networks.css";
import '../styles/section.css';
import '../styles/tables.css';
import Utilities from "../util/Utilities";
import RespUtils from "../util/RespUtils";

import MainUtils from "../main/MainUtils";
import LastUpdated from '../components/LastUpdated';
import LogoUtils from '../util/LogoUtils';
import constants from '../constants';
import PageHeader from '../components/PageHeader';
import ProjectUIUtils from '../projects/ProjectUIUtils';
import CoinUtils from '../util/CoinUtils';
import NetworkUtils from './NetworkUtils';
import StakeUtils from '../util/StakeUtils';

class Networks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      data: [],
      notification: {"message": null},
      width: window.innerWidth,
      size: 10,
      lastUpdated: "",
      isLoading: true,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
    this.reload = this.reload.bind(this);
    this.getInitColumns = this.getInitColumns.bind(this);
    this.repaintData = this.repaintData.bind(this);    
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    let url = "listData?type=decentralization"
    // console.log(url);

    const allData = await ApiUtils.get(url);
    // console.log(allData);
    if (!allData) {
      this.setState({error: true, isLoading: false});
      return;
    }

    let data = allData["data"];
    let lastUpdated = allData["lastUpdated"];
    if (data) {
      let newData = Utilities.addIndex(data);
      let notification = allData["notification"];
      this.setState({lastUpdated: lastUpdated, notification: notification, data: newData});
    }

    this.setState({isLoading: false});
  }

  repaintData() {
    let data = this.state.data;
    let newData = Utilities.addIndex(data);
    this.setState({data: newData});
  }

  render() {
    let loadMsg = UIUtils.getLoading(this);

    if (loadMsg) return loadMsg;

    const headerSortingClasses = (column, sortOrder, isLastSorting, colIndex) => (
      sortOrder === 'asc' ? 'sorting-asc' : 'sorting-desc'
    );

    var columns = [
      {text: "#", desc: "Index", hidden: this.isHidden("index"), dataField: "index", sort: true, align: "left", headerStyle: Utilities.respWidth(5, 4, 3), headerSortingClasses},
      {text: "", desc: "logo", dataField: "logo", sort: true, formatter: LogoUtils.projectLogo, headerStyle: Utilities.respWidth(8, 6, 4)},
      {text: "Network",  desc: "Network Name", hidden: this.isHidden("name"), dataField: "name", formatter: NetworkUtils.networkFormatter, sort: true, headerStyle: Utilities.respWidth(35, 20, 15), headerSortingClasses},
      {text: "Media",  desc: "Media links for the network", hidden: this.isHidden("media"), dataField: "twitter", formatter: ProjectUIUtils.formatMediaSmall, sort: true, headerStyle:  Utilities.respWidth(30, 20, 15), headerSortingClasses},
      {text: Utilities.respLabel("MCap", "Market Cap", "Market Cap"),  desc: "Market Cap of the network", hidden: this.isHidden("usdMcap"), dataField: "usdMcap", formatter: UIUtils.coingeckoLinkFromMcap, sort: true, headerStyle: Utilities.respWidth(20, 15, 8), headerSortingClasses},
      {text: "Total Supply*",  desc: "Total Supply", hidden: this.isHidden("totalSupply"), dataField: "totalSupply", formatter: CoinUtils.stakeFormatterRounded, sort: true, sortFunc: Utilities.sortNumeric, headerStyle:  Utilities.respWidth(20, 15, 8), headerSortingClasses},
      {text: "Total Stake*",  desc: "Total Staked", hidden: this.isHidden("totalStake"), dataField: "totalStake", formatter: CoinUtils.stakeFormatterRounded, sort: true, sortFunc: Utilities.sortNumeric, headerStyle:  Utilities.respWidth(20, 15, 8), headerSortingClasses},
      {text: "Total Stake USD*",  desc: "Total Staked USD", hidden: this.isHidden("totalStakeUsd"), dataField: "totalStakeUsd", formatter: CoinUtils.tokenUsdValueFormatter, sort: true, sortFunc: Utilities.sortNumeric, headerStyle:  Utilities.respWidth(20, 15, 8), headerSortingClasses},
      {text: "Percent Staked*",  desc: "Percentage of circulation that is staked", hidden: this.isHidden("percentStaked"), dataField: "percentStaked", formatter: CoinUtils.percentFormatter, sort: true, sortFunc: Utilities.sortNumeric, headerStyle:  Utilities.respWidth(20, 15, 8), headerSortingClasses},
      {text: "Staking APR",  desc: "Expected Staking APR", hidden: this.isHidden("currentRewardRate"), dataField: "currentRewardRate", formatter: CoinUtils.aprFormatter, sort: true, sortFunc: Utilities.sortNumeric, headerStyle:  Utilities.respWidth(20, 15, 8), headerSortingClasses},
      {text: Utilities.respLabel("Median Comm", "Median Commission", "Median Commission"),  desc: "Median commission", hidden: this.isHidden("medianFee"), dataField: "medianFee", formatter: MainUtils.percentFormatter, sort: true, headerStyle: Utilities.width(8), headerSortingClasses},
      {text: Utilities.respLabel("Weighted Median", "Weighted Median", "Weighted Median Commission"),  desc: "Weighted Median commission", hidden: this.isHidden("weightedMedianCommission"), dataField: "weightedMedianCommission", formatter: MainUtils.percentFormatter, sort: true, headerStyle:  Utilities.respWidth(20, 15, 12), headerSortingClasses},
      {text: Utilities.respLabel("Addresses", "Addresses", "Addresses (>0 balance)"), desc: "Total number of addresses with >0 balance", hidden: this.isHidden("activeAccounts"), dataField: "activeAccounts", formatter: NetworkUtils.activeAccountFormatter, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10), headerSortingClasses},
      {text: "Recent Avg Votes",  desc: "Average voter count in latest 10 finished/non-spam proposals", hidden: this.isHidden("recentAvgVotes"), dataField: "recentAvgVotes", formatter: NetworkUtils.formatPropData, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10), headerSortingClasses},
      {text: "Recent Max Votes",  desc: "Max voter count among latest 10 finished/non-spam proposals", hidden: this.isHidden("recentMaxVotes"), dataField: "recentMaxVotes", formatter: NetworkUtils.formatPropData, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10), headerSortingClasses},
      {text: "Unique Delegates",  desc: "Total number of unique delegates", hidden: this.isHidden("uniqueDelegates"), dataField: "uniqueDelegates", formatter: NetworkUtils.uniqueDelegatesFormatter, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(10), headerSortingClasses},
      {text: "Average Delegation (USD)",  desc: "Average Delegation of all delegates for the validator", hidden: this.isHidden("averageDelegationUsd"), dataField: "averageDelegationUsd", formatter: StakeUtils.formatAverageDelegationUsd, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(12), headerSortingClasses},
      // {text: "Unique Delegations",  desc: "Total number of unique delegations", hidden: this.isHidden("uniqueDelegations"), dataField: "uniqueDelegations", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.width(13), headerSortingClasses},
      {text: "# of Validators",  desc: "Number of Validators", hidden: this.isHidden("consensusValidators"), dataField: "consensusValidators", sort: true, sortFunc: Utilities.sortNumeric, headerStyle:  Utilities.respWidth(20, 15, 7), headerSortingClasses},
      {text: "Average Voting Power",  desc: "Average Voting Power", hidden: this.isHidden("avgVotingPower"), dataField: "avgVotingPower", formatter: CoinUtils.usdFormatter, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(20, 15, 10), headerSortingClasses},
      {text: "Val Below Avg Voting Power",  desc: "Validators below Average Voting Power", hidden: this.isHidden("valBelowAvgPower"), dataField: "valBelowAvgPower", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(20, 15, 10), headerSortingClasses},
      // {text: Utilities.respLabel("Validators 4 Net Halt", "Validators 4 Network Halt", "Validators for Network Halt"),  desc: "Minimum Validators that can halt network", hidden: this.isHidden("valForNetworkHalt"), dataField: "valForNetworkHalt", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(20, 15, 10), headerSortingClasses},
      {text: Utilities.respLabel("Nakamoto", "Nakamoto Coefficient", "Nakamoto Coefficient"),  desc: "Network Coefficient", hidden: this.isHidden("nakamotoIndex"), dataField: "nakamotoIndex", formatter: NetworkUtils.formatNakamoto, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},
      {text: Utilities.respLabel("Gini", "Gini Coefficient", "Gini Coefficient"),  desc: "Gini Coefficient", hidden: this.isHidden("gini"), dataField: "gini", formatter: NetworkUtils.formatGini, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},
      {text: Utilities.respLabel("Top 1 = Bottom N %", "Top 1 = Bottom N %", "Top 1 equals bottom N Val %"),  desc: "Top 1 equals bottom N validators in percent", hidden: this.isHidden("oneEqualsNBottomValPercent"), dataField: "oneEqualsNBottomValPercent", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},
      {text: Utilities.respLabel("Top 1 = Bottom N #", "Top 1 = Bottom N #", "Top 1 equals bottom N Val #"),  desc: "Top 1 equals bottom N validators in count", hidden: this.isHidden("oneEqualsNBottomVal"), dataField: "oneEqualsNBottomVal", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},
      {text: Utilities.respLabel("Top 100 Del Share", "Top 100 Del Share", "Top 100 Delegate Stake Share"),  desc: "Share of total stake by top 100 delegates", hidden: this.isHidden("top100StakeShare"), dataField: "top100StakeShare", formatter: CoinUtils.percentFormatter, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},
      {text: Utilities.respLabel("Pending Undelegations", "Pending Undelegations", "Pending Undelegations Count"),  desc: "Pending Undelegations Count", hidden: this.isHidden("uniqueUndelegations"), dataField: "uniqueUndelegations", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},
      {text: Utilities.respLabel("Undel Amt", "Undelegation Amount", "Pending Undelegation Amount"),  desc: "Pending Undelegation Amount", hidden: this.isHidden("totalUndelegationAmount"), dataField: "totalUndelegationAmount", formatter: CoinUtils.stakeFormatterRounded, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},
      {text: Utilities.respLabel("Undel Amt % of Total", "Undel Amt % of Total", "Undel Amt % of Total Supply"),  desc: "Undelegation Amount % of Total Supply", hidden: this.isHidden("undelPercentOfTotalSupply"), dataField: "undelPercentOfTotalSupply", formatter: CoinUtils.percentFormatter, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},
      {text: Utilities.respLabel("Undel Amt % of Not Staked", "Undel Amt % of Not Staked", "Undel Amt % of Not Staked Supply"),  desc: "Undelegation Amount % of Not Staked Supply", hidden: this.isHidden("undelPercentOfNotStakedSupply"), dataField: "undelPercentOfNotStakedSupply", formatter: CoinUtils.percentFormatter, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},
      {text: Utilities.respLabel("24h Txs", "24h Transactions", "24h Transactions"),  desc: "24h Transactions Count", hidden: this.isHidden("txCount24h"), dataField: "txCount24h", formatter: NetworkUtils.format24hTxs, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},
      {text: "24h Active Addresses",  desc: "24h Active Addresses", hidden: this.isHidden("activeAddress24h"), dataField: "activeAddress24h", formatter: NetworkUtils.format24hAddresses, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},

      {text: Utilities.respLabel("Successful Txs", "Successful Txs", "Successful Transactions"),  desc: "Successful Transactions in 24h", hidden: this.isHidden("successfulTxs"), dataField: "successfulTxs", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},
      {text: Utilities.respLabel("Failed Txs", "Failed Txs", "Failed Transactions"),  desc: "Failed Transactions in 24h", hidden: this.isHidden("failedTxs"), dataField: "failedTxs", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},
      {text: Utilities.respLabel("Last Val Stake USD", "Last Val Stake USD", "Last Validator Stake USD"),  desc: "Last Validator Stake in USD", hidden: this.isHidden("lastValStakeUsd"), dataField: "lastValStakeUsd", formatter: CoinUtils.tokenUsdValueFormatter, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},
      {text: Utilities.respLabel("Last Val Stake", "Last Val Stake", "Last Validator Stake"),  desc: "Last Validator Stake", hidden: this.isHidden("lastValStake"), dataField: "lastValStake", sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(15, 15, 8), headerSortingClasses},

      {text: "Analytics",  desc: "Smart Stake Analytics", hidden: this.isHidden("analyticsWebsite"), dataField: "analyticsWebsite", sort: false, formatter: NetworkUtils.renderAnalytics, formatExtraData: this, headerStyle:  Utilities.respWidth(20, 15, 10)},
    ];
    
    const options = {
      onlyOneExpanding: true
    };

    const expandRow = {
      renderer: row => (
        <div>
          <NetworkInline network={row}/>
          <hr/>
        </div>
      ), showExpandColumn: false
    };

    return (
      <div>
        <PageHeader title="Decentralization Metrics" thisObj={this} beta={false}/>
        <p/>
        <ReactTooltip id="main" place="top" type="dark" effect="float" multiline={true} />
        <ToolkitProvider keyField="symbol" data={this.state.data} columns={columns} columnToggle>
          {
            props => (
              <div>
                <ValColumnSelector settingKey={constants.app.CHAINS_KEY} getInitColumns={this.getInitColumns}
                  { ...props.columnToggleProps } refreshParent={this.repaintData} />
                <BootstrapTable options={options} { ...props.baseProps }
                    expandRow={ expandRow }
                    expandableRow={ () => { return true; } }
                    condensed noDataIndication="No records" />
              </div>
            )
          }
        </ToolkitProvider>
        <CollapsibleNote getScreenGuide={NetworkUtils.getDisclaimer} label="Disclaimer / Notes" />
        <p/>
        <CollapsibleNote getScreenGuide={NetworkUtils.getScreenGuide} />
        <p/>
        <LastUpdated thisObj={this} recentBlock={false} />
        <p>This website publishes data from networks supported by Smart Stake as a validator.</p>
        <Contact />
      </div>
    );
  }
  // <CollapsibleNote getScreenGuide={MainNotes.getPoolNote} />


  reload() {
    window.location = "/";
  }

  getInitColumns() {
    let columnsConfig = {};
    if (RespUtils.isTabletView()) {
      columnsConfig = {
        index:true, logoPath: false, name: false, media: true, 
        usdMcap: true, consensusValidators: true, percentStaked: true, currentRewardRate: true, 
        medianFee: true, weightedMedianCommission: true, uniqueDelegates: true, 
        avgVotingPower: true, valBelowAvgPower: true, gini: false, averageDelegationUsd: true, 
        analyticsWebsite: true, nakamotoIndex: false, activeAccounts: true, 
        top100StakeShare: true, undelPercentOfTotalSupply: true, undelPercentOfNotStakedSupply: true, 
        totalUndelegationAmount: true, uniqueUndelegations: true, totalSupply: true, totalStake: true, 
        oneEqualsNBottomVal: true, oneEqualsNBottomValPercent: true, txCount24h: true, activeAddress24h: true, 
        successfulTxs: true, failedTxs: true, lastValStake: true, lastValStakeUsd: true, totalStakeUsd: true,
        recentAvgVotes: true, recentMaxVotes: true,
      };
    } else {
      columnsConfig = {
        index:false, logoPath: false, name: false, media: true, 
        usdMcap: false, consensusValidators: false, percentStaked: false, currentRewardRate: false, 
        medianFee: true, weightedMedianCommission: true, uniqueDelegates: false, 
        avgVotingPower: true, valBelowAvgPower: false, gini: false, averageDelegationUsd: true,
        analyticsWebsite: false, nakamotoIndex: false, activeAccounts: false, 
        top100StakeShare: true, undelPercentOfTotalSupply: true, undelPercentOfNotStakedSupply: true, 
        totalUndelegationAmount: true, uniqueUndelegations: true, totalSupply: true, totalStake: true, 
        oneEqualsNBottomVal: true, oneEqualsNBottomValPercent: false, txCount24h: true, activeAddress24h: true, 
        successfulTxs: true, failedTxs: true, lastValStake: true, lastValStakeUsd: true, totalStakeUsd: true,
        recentAvgVotes: true, recentMaxVotes: true,
      };
    }

    // console.log("columns config is: ", columnsConfig);
    return columnsConfig;
  }

  isHidden(dataField) {
    return UITableUtils.isHidden(constants.app.CHAINS_KEY, dataField, this.getInitColumns);
  }

}

export default Networks;



// WEBPACK FOOTER //
// ./src/network/Networks.js